export default __webpack_public_path__ + "universal/images/logo.50fb2001d55723437d554ceead1c526f.svg";